import React from 'react'

export interface EmptyCardListProps {
  children: React.ReactNode
}

export const EmptyCardList: React.FC<EmptyCardListProps> = ({ children }) => (
  <div className='my-c-empty-card-list my-u-p--12 ds-u-text-align--center ds-u-font-size--lg'>
    {children}
  </div>
)
